import { render } from "./status-bar-info-chart.vue?vue&type=template&id=45c70c84&scoped=true"
import script from "./status-bar-info-chart.vue?vue&type=script&lang=js"
export * from "./status-bar-info-chart.vue?vue&type=script&lang=js"

import "./status-bar-info-chart.vue?vue&type=style&index=0&id=45c70c84&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c70c84"]])

export default __exports__
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QResizeObserver,QTooltip});
